/**
 * @returns {undefined|'production'|'staging'}
 */
export function getEnvironment() {
  let env;

  if (process?.env) {
    const nodeEnv = (process.env.NODE_ENV || process.env.ENV || '')?.toLowerCase();
    const nodeEnvIsProd = nodeEnv === 'production';
    const dopplerEnvIsProd = process.env.DOPPLER_ENVIRONMENT === 'prd';
    const domainIsProd = (process.env.DOMAIN || '')?.endsWith('.com');

    if (nodeEnvIsProd || dopplerEnvIsProd || domainIsProd) {
      env = 'production';
    } else {
      env = 'staging';
    }
  }

  return env;
}

export default {
  getEnvironment,
};
